import { createContext } from 'react';

/**
 * True for everything rendered in a Tooltip's trigger seat.
 *
 * Internal, never exported through the barrel. It carries two contracts:
 *
 * - Button and IconButton, when disabled inside a Tooltip, switch from the
 *   native disabled attribute to the aria-disabled form (still focusable and
 *   hover-capable, presses and form submission suppressed), because a
 *   natively disabled element fires no interactions and the tooltip that
 *   explains WHY it is disabled could never open.
 * - IconButton's built-in label tooltip stands down when an explicit Tooltip
 *   already holds the seat, so the outer tooltip (the disabledTooltip swap
 *   idiom) wins instead of doubling up.
 */
export const TooltipSeatContext = createContext(false);
